// ** Logo
// import logo from "@src/assets/images/logo/logo.png"
import logo from "@src/assets/images/logo/Qalqon.png"

const SpinnerComponent = () => {
  const skin = localStorage.getItem("skin")
  return (
    <div className={`fallback-spinner vh-100 theme-dark-body-bg`}>
      {/* <img style={{ width: 80, height: 90 }} className="fallback-logo" src={logo} alt="logo" /> */}
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  )
}

export default SpinnerComponent
